import { render, staticRenderFns } from "./bjtm.vue?vue&type=template&id=8584b858&scoped=true&"
import script from "./bjtm.vue?vue&type=script&lang=js&"
export * from "./bjtm.vue?vue&type=script&lang=js&"
import style0 from "./bjtm.vue?vue&type=style&index=0&id=8584b858&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8584b858",
  null
  
)

export default component.exports